import Tooltip from "@mui/material/Tooltip";
import { MdPendingActions } from "react-icons/md";
import { BsFillCloudArrowUpFill } from "react-icons/bs";

import {
  HiOutlineClipboardList,
  HiOutlineDocument,
  HiOutlineMail,
  HiOutlineTrash,
} from "react-icons/hi";

import { Link } from "react-router-dom";
import { useRoleContext } from "../../context/RolesContext";

// Compact vertical icon menu shown from the dashboard's floating Shortcuts
// button. Each entry keeps the exact same permission gating, route, and
// click handler as before — only the visual treatment (small icon + hover
// tooltip instead of a large circle with a text label) changed.
function ShortcutCards({ toggleAddDocumentForm, onAddUserButtonClick, is_admin }) {
  const { permissions } = useRoleContext();
  const hasPermission = (permission) => {
    if (is_admin === "1") {
      return true;
    }
    return permissions.includes(permission);
  };
  const canAddDocument = hasPermission("create_all_documents");
  const canViewRequests = hasPermission("view_requested_documents");
  const canAddUser = hasPermission("create_users");
  const canViewClients = hasPermission("view_clients");
  const canViewTrashUser = hasPermission("view_trash_users");
  const canViewTrashDoc = hasPermission("view_trash_documents");

  const iconButtonClass =
    "w-10 h-10 flex items-center justify-center rounded-full text-lg shadow-sm transition-transform hover:scale-110";
  const disabledClass = "opacity-40 cursor-not-allowed hover:scale-100";

  return (
    <div className="flex flex-col gap-2 p-2 border-gray-100">
      <Tooltip title="Add Doc" placement="left" arrow>
        <span>
          <button
            type="button"
            className={`${iconButtonClass} bg-teal-50 text-[#1a6b7c] ${
              !canAddDocument ? disabledClass : ""
            }`}
            disabled={!canAddDocument}
            onClick={toggleAddDocumentForm}
          >
            <BsFillCloudArrowUpFill />
          </button>
        </span>
      </Tooltip>

      <Tooltip title="Add User" placement="left" arrow>
        <span>
          <button
            type="button"
            className={`${iconButtonClass} bg-teal-100 text-teal-700 ${
              !canAddUser ? disabledClass : ""
            }`}
            disabled={!canAddUser}
            onClick={onAddUserButtonClick}
          >
            <HiOutlineClipboardList />
          </button>
        </span>
      </Tooltip>

      <Tooltip title="Requests" placement="left" arrow>
        <span>
          {canViewRequests ? (
            <Link
              to="/requests"
              className={`${iconButtonClass} bg-amber-100 text-amber-700`}
            >
              <MdPendingActions />
            </Link>
          ) : (
            <div className={`${iconButtonClass} bg-amber-100 text-amber-700 ${disabledClass}`}>
              <MdPendingActions />
            </div>
          )}
        </span>
      </Tooltip>

      <Tooltip title="Clients" placement="left" arrow>
        <span>
          {canViewClients ? (
            <Link
              to="/clients"
              className={`${iconButtonClass} bg-teal-50 text-[#1a6b7c]`}
            >
              <HiOutlineMail />
            </Link>
          ) : (
            <div className={`${iconButtonClass} bg-teal-50 text-[#1a6b7c] ${disabledClass}`}>
              <HiOutlineMail />
            </div>
          )}
        </span>
      </Tooltip>

      <Tooltip title="Trash User" placement="left" arrow>
        <span>
          {canViewTrashUser ? (
            <Link
              to="/trash-users"
              className={`${iconButtonClass} bg-gray-100 text-gray-700`}
            >
              <HiOutlineTrash />
            </Link>
          ) : (
            <div className={`${iconButtonClass} bg-gray-100 text-gray-700 ${disabledClass}`}>
              <HiOutlineTrash />
            </div>
          )}
        </span>
      </Tooltip>

      <Tooltip title="Trash Doc" placement="left" arrow>
        <span>
          {canViewTrashDoc ? (
            <Link
              to="/trash-documents"
              className={`${iconButtonClass} bg-gray-100 text-gray-700`}
            >
              <HiOutlineDocument />
            </Link>
          ) : (
            <div className={`${iconButtonClass} bg-gray-100 text-gray-700 ${disabledClass}`}>
              <HiOutlineDocument />
            </div>
          )}
        </span>
      </Tooltip>
    </div>
  );
}

export default ShortcutCards;
